import type { AnalyticsPayload } from "@/analytics/ga4";

export interface AnalyticsContext extends AnalyticsPayload {
  surface?: string;
  route_template?: string;
  workspace_id?: string;
  project_id?: string;
  task_id?: string;
  user_role?: "user" | "platform_admin";
  workspace_team_size?: "solo" | "small_team" | "growing";
  workspace_industry?: string;
  is_authenticated?: boolean;
  is_returning_user?: boolean;
}

const contextState: AnalyticsContext = {};

export const setAnalyticsContext = (patch: AnalyticsContext): void => {
  const next: AnalyticsContext = { ...contextState, ...patch };
  for (const key of Object.keys(next) as Array<keyof AnalyticsContext>) {
    if (next[key] === undefined || next[key] === null) {
      delete next[key];
    }
  }

  for (const key of Object.keys(contextState) as Array<keyof AnalyticsContext>) {
    delete contextState[key];
  }
  Object.assign(contextState, next);
};

export const getAnalyticsContext = (): AnalyticsContext => ({ ...contextState });

export const resetAnalyticsContext = (): void => {
  for (const key of Object.keys(contextState) as Array<keyof AnalyticsContext>) {
    delete contextState[key];
  }
};

export const normalizeRouteTemplate = (pathname: string): string => {
  if (!pathname || pathname === "/") return "/";

  if (/^\/tasks\/[^/]+$/.test(pathname)) return "/tasks/:taskId";
  if (/^\/agents\/[^/]+$/.test(pathname)) return "/agents/:agentId";
  if (/^\/onboarding\/workspace$/.test(pathname)) return "/onboarding/workspace";
  if (/^\/onboarding\/wizard$/.test(pathname)) return "/onboarding/wizard";
  if (/^\/settings\/profile$/.test(pathname)) return "/settings/profile";
  if (/^\/settings\/notifications$/.test(pathname)) return "/settings/notifications";
  if (/^\/settings\/integrations$/.test(pathname)) return "/settings/integrations";
  if (/^\/settings\/team$/.test(pathname)) return "/settings/team";
  if (/^\/settings\/archive$/.test(pathname)) return "/settings/archive";
  if (/^\/workspace-picker$/.test(pathname)) return "/workspace-picker";

  return pathname;
};
